var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "elementType": "div",
      "customClass": [_vm.customsClasses]
    }
  }, [_vm.showControlLeft ? _c('CustomText', {
    attrs: {
      "elementType": "a",
      "text": _vm.controlLeftText,
      "customClass": "control-left"
    },
    on: {
      "click": _vm.zoomIn
    }
  }) : _vm._e(), _c('CustomInput', {
    attrs: {
      "customClass": "custom-input",
      "type": "range",
      "min": _vm.min,
      "max": _vm.max,
      "step": _vm.step,
      "value": _vm.zoomValue
    },
    on: {
      "input": _vm.onChange
    }
  }), _vm.showControlRight ? _c('CustomText', {
    attrs: {
      "elementType": "a",
      "text": _vm.controlRightText,
      "customClass": "control-right"
    },
    on: {
      "click": _vm.zoomOut
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }